import React, { useState } from "react";
import { Container, Row, Col, Button, ProgressBar, Form } from "react-bootstrap";
import { useLocalStorage } from "../../useLocalStorage";
import config from "./config.json";

const Step6 = ({ prevStep, onSuccess }) => {
  const currentStep = 6;

  const [dataLocal, setDataLocal] = useLocalStorage("audit_energetique_step6", {
    civility: "",
    firstname: "",
    lastname: "",
    phone: "",
    email: ""
  });

  const [isSubmitting, setIsSubmitting] = useState(false);
  const [errorSubmit, setErrorSubmit] = useState(null);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setDataLocal((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmitGlobal = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    setErrorSubmit(null);

    // 1) Récupération des données des autres steps
    const type_bien = localStorage.getItem("type_bien") || null;
    const construction_date = localStorage.getItem("construction_date") || null;

    const step3 = (() => {
      try {
        return JSON.parse(localStorage.getItem("audit_energetique")) || {};
      } catch {
        return {};
      }
    })();

    const step4 = (() => {
      try {
        return JSON.parse(localStorage.getItem("audit_energetique_step4")) || {};
      } catch {
        return {};
      }
    })();

    const step5 = (() => {
      try {
        return JSON.parse(localStorage.getItem("audit_energetique_step5")) || {};
      } catch {
        return {};
      }
    })();

    // 2) Construction du payload (sans foyer / revenu)
    const payload = {
      type_bien,
      construction_date,
      habitable_surface: step3.habitable_surface || null,
      project: step3.project || null, // si tu l’utilises un jour
      start_work: step5.start_work || null,
      address: step4.address || null,
      postcode: step4.postcode || null,
      city: step4.city || null,
      latitude: step4.latitude || null,
      longitude: step4.longitude || null,
      civility: dataLocal.civility || null,
      firstname: dataLocal.firstname || null,
      lastname: dataLocal.lastname || null,
      phone: dataLocal.phone || null,
      email: dataLocal.email || null
    };

    if (!payload.email || !payload.phone || !payload.address) {
      setIsSubmitting(false);
      setErrorSubmit("Merci de renseigner au minimum l'email, le téléphone et l'adresse.");
      return;
    }

    try {
const res = await fetch(
  "/wp-content/plugins/tunneldevente-energia/save_lead.php",
  {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(payload),
  }
);

const raw = await res.text(); // <-- on lit le texte brut

let data;
try {
  data = JSON.parse(raw);
} catch (e) {
  console.error("Réponse brute du serveur :", raw);
  throw new Error("Réponse serveur invalide (pas du JSON).");
}

if (!res.ok || !data.success) {
  throw new Error(data.error || "Erreur lors de l'enregistrement.");
}


      if (onSuccess) onSuccess(data);
    } catch (err) {
      console.error(err);
      setErrorSubmit(err.message);
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <Container>
      <ProgressBar now={(currentStep / config.totalSteps) * 100} />

      <Form onSubmit={handleSubmitGlobal}>
        <Row className="mt-3">
          <Col>
            <h2>{config.step6.step}</h2>
            <h3>{config.step6.title}</h3>
            <p>{config.step6.label}</p>

            {errorSubmit && (
              <div className="alert alert-danger mt-3">{errorSubmit}</div>
            )}
          </Col>
        </Row>

        {/* Civilité */}
        <Row className="mb-3 justify-content-center">
          <Col md={6} offset={3}>
            <Form.Label className="text-start">Civilité</Form.Label>
            <div>
              <Form.Check
                inline
                type="radio"
                label="Monsieur"
                name="civility"
                value="monsieur"
                checked={dataLocal.civility === "monsieur"}
                onChange={handleChange}
              />
              <Form.Check
                inline
                type="radio"
                label="Madame"
                name="civility"
                value="madame"
                checked={dataLocal.civility === "madame"}
                onChange={handleChange}
              />
            </div>
          </Col>
        </Row>

        {/* Nom / Prénom */}
        <Row className="mb-3">
          <Col md={6}>
            <Form.Label className="text-start">Prénom</Form.Label>
            <Form.Control
              type="text"
              name="firstname"
              value={dataLocal.firstname}
              onChange={handleChange}
              required
            />
          </Col>
          <Col md={6}>
            <Form.Label className="text-start">Nom</Form.Label>
            <Form.Control
              type="text"
              name="lastname"
              value={dataLocal.lastname}
              onChange={handleChange}
              required
            />
          </Col>
        </Row>

        {/* Téléphone / Email */}
        <Row className="mb-3">
          <Col md={6}>
            <Form.Label className="text-start">Téléphone</Form.Label>
            <Form.Control
              type="tel"
              name="phone"
              value={dataLocal.phone}
              onChange={handleChange}
              required
            />
          </Col>
          <Col md={6}>
            <Form.Label className="text-start">Email</Form.Label>
            <Form.Control
              type="email"
              name="email"
              value={dataLocal.email}
              onChange={handleChange}
              required
            />
          </Col>
        </Row>

        <Row className="mt-3">
          <Col className="d-flex justify-content-between">
            <Button
              variant="secondary"
              onClick={prevStep}
              disabled={isSubmitting}
              type="button"
            >
              Précédent
            </Button>
            <Button
              variant="primary"
              type="submit"
              disabled={isSubmitting}
            >
              {isSubmitting ? "Envoi en cours..." : "Valider et envoyer"}
            </Button>
          </Col>
        </Row>
      </Form>
    </Container>
  );
};

export default Step6;
